const values = [
  {
    icon: 'ri-focus-3-line',
    title: 'iOS-First Thinking',
    description:
      'We build exclusively for the iOS platform, allowing us to go deeper, optimize harder, and deliver a truly native experience that cross-platform tools simply cannot match.',
  },
  {
    icon: 'ri-team-line',
    title: 'Expert Team',
    description:
      'Our engineers bring years of dedicated iOS development experience, combining technical precision with a genuine passion for building software that people trust.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'User-Centered Design',
    description:
      'Every interaction is designed for clarity and simplicity. Security and performance tools should feel effortless — we make complex technology invisible to the user.',
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-24 md:py-32 bg-white px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left: main copy */}
          <div className="flex flex-col gap-8">
            <div>
              <p className="text-xs text-stone-400 tracking-[0.3em] uppercase font-medium mb-4">About Us</p>
              <h2
                className="text-4xl md:text-5xl font-bold text-stone-900 leading-tight"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                A Team Obsessed<br />
                <span className="italic font-normal text-stone-600">with iOS Excellence</span>
              </h2>
            </div>

            <p className="text-stone-600 text-base leading-relaxed">
              CHIKO OOD was founded with a single guiding principle: the iOS ecosystem deserves purpose-built applications that respect users and deliver on their promises.
            </p>
            <p className="text-stone-500 text-sm leading-relaxed">
              We are a focused, expert-driven studio. Rather than building dozens of average apps, we choose depth over breadth — crafting two flagship products that we continually refine, secure, and improve. Our VPN and Cleaner applications are used by privacy-conscious individuals who demand the best from their devices.
            </p>
            <p className="text-stone-500 text-sm leading-relaxed">
              Headquartered in Peshtera, Bulgaria, CHIKO OOD operates with the discipline of an engineering firm and the attention to detail of a design studio. Every release is carefully tested, every security update is swift, and every user complaint is taken seriously.
            </p>

            {/* Image */}
            <div className="w-full h-56 rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/9bf89e45b2e46250628acd7be60ce09d.jpg"
                alt="CHIKO OOD workspace"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right: values */}
          <div className="flex flex-col gap-8 lg:pt-16">
            {values.map((v) => (
              <div key={v.title} className="flex gap-5 group">
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-stone-100 flex-shrink-0">
                  <i className={`${v.icon} text-lg text-stone-700`} />
                </div>
                <div className="flex flex-col gap-1.5">
                  <h3 className="text-base font-semibold text-stone-900">{v.title}</h3>
                  <p className="text-sm text-stone-500 leading-relaxed">{v.description}</p>
                </div>
              </div>
            ))}

            {/* Quote */}
            <div className="mt-4 border-l-2 border-stone-200 pl-6">
              <p className="text-stone-500 text-sm italic leading-relaxed">
                "We believe that great mobile software is invisible — it just works, keeps you safe, and stays out of your way."
              </p>
              <span className="text-xs text-stone-400 tracking-wide mt-2 block">— CHIKO OOD Team</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
